import { render, staticRenderFns } from "./textRound.vue?vue&type=template&id=28e5b51f&scoped=true&"
import script from "./textRound.vue?vue&type=script&lang=js&"
export * from "./textRound.vue?vue&type=script&lang=js&"
import style0 from "./textRound.vue?vue&type=style&index=0&id=28e5b51f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5b51f",
  null
  
)

export default component.exports